import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "pin-area-container"
}

import { onMounted } from 'vue';
import { BOTTOM, CENTER, LEFT, RIGHT } from '@shell/utils/position';
import useDragHandler from './composables/useDragHandler';
import { Z_INDEX } from './constants';

/**
 * This component is responsible for rendering the pin area used during tab dragging.
 *
 * Behavior:
 * - Enable drag areas for each position (left, right, bottom, center) when dragging is active.
 * - Highlights the area where the tab can be pinned.
 * - Uses z-index variables to ensure proper layering of drag areas.
 */


export default /*@__PURE__*/_defineComponent({
  __name: 'PinArea',
  setup(__props) {

const {
  dragOverPositionsActive, pin, pinArea, lockedPositions, onDragPositionOver
} = useDragHandler();

onMounted(() => {
  Object.keys(Z_INDEX).forEach((key) => {
    document.documentElement.style.setProperty(
      `--drag-area-${ key.toLowerCase().replaceAll('_', '-') }-z-index`, (Z_INDEX as any)[key].toString()
    );
  });
});

return (_ctx: any,_cache: any) => {
  return (_unref(dragOverPositionsActive))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_unref(pinArea) != _unref(pin))
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: _normalizeClass(["pin-effect-area", _unref(pinArea)])
            }, null, 2))
          : _createCommentVNode("", true),
        _cache[4] || (_cache[4] = _createTextVNode()),
        _createElementVNode("span", {
          class: "drag-area center",
          onDragover: _cache[0] || (_cache[0] = ($event: any) => (_unref(onDragPositionOver)($event, _unref(CENTER))))
        }, null, 32),
        _cache[5] || (_cache[5] = _createTextVNode()),
        (!_unref(lockedPositions).includes(_unref(RIGHT)))
          ? (_openBlock(), _createElementBlock("span", {
              key: 1,
              class: "drag-area right",
              onDragover: _cache[1] || (_cache[1] = ($event: any) => (_unref(onDragPositionOver)($event, _unref(RIGHT))))
            }, null, 32))
          : _createCommentVNode("", true),
        _cache[6] || (_cache[6] = _createTextVNode()),
        (!_unref(lockedPositions).includes(_unref(LEFT)))
          ? (_openBlock(), _createElementBlock("span", {
              key: 2,
              class: "drag-area left",
              onDragover: _cache[2] || (_cache[2] = ($event: any) => (_unref(onDragPositionOver)($event, _unref(LEFT))))
            }, null, 32))
          : _createCommentVNode("", true),
        _cache[7] || (_cache[7] = _createTextVNode()),
        (!_unref(lockedPositions).includes(_unref(BOTTOM)))
          ? (_openBlock(), _createElementBlock("span", {
              key: 3,
              class: "drag-area bottom",
              onDragover: _cache[3] || (_cache[3] = ($event: any) => (_unref(onDragPositionOver)($event, _unref(BOTTOM))))
            }, null, 32))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})